<template>
  <span
    class="pointer-events-none rounded-lg bg-gray-500 px-2 py-1 text-xs normal-case text-white absolute -top-7 left-4 w-max max-w-64 opacity-0 transition-opacity z-50"
    :class="{ 'opacity-100': showTooltip }"
  >
    {{ textValue }}
  </span>
</template>
<script>
export default {
  props: {
    textValue: String,
  },
  data() {
    return {
      showTooltip: false,
    };
  },
  methods: {
    show() {
      this.showTooltip = true;
    },
    hide() {
      this.showTooltip = false;
    },
  },
};
</script>
